import { Controller } from "@hotwired/stimulus"
import { consentDecided, hasAnalyticsConsent, setConsent } from "../consent"

// Cookie consent banner UI (#511). The state + persistence live in `../consent`;
// this controller only drives the banner: show it when there is no current
// decision (default-deny), persist the user's granular choice, and reopen on
// demand (the footer "Preferências de cookies" dispatches `opinaki:open-consent`).
//
// The banner starts `hidden` in the markup, so a visitor who already decided
// never sees a flash — and without JS it simply never shows (fail-closed: no
// banner, no tracking).
export default class extends Controller {
  static targets = [ "panel", "analytics" ]

  connect() {
    // Show only when undecided OR the consent_version was bumped (the consent
    // module treats a stale version as undecided).
    if (!consentDecided()) this.open()

    this.onReopen = () => this.open()
    document.addEventListener("opinaki:open-consent", this.onReopen)
  }

  disconnect() {
    if (this.onReopen) document.removeEventListener("opinaki:open-consent", this.onReopen)
  }

  // Reveal the banner, reflecting the current choice in the granular toggle so
  // reopening shows the real state (not a stale default).
  open() {
    if (this.hasAnalyticsTarget) this.analyticsTarget.checked = hasAnalyticsConsent()
    this.element.hidden = false
  }

  acceptAll() {
    setConsent({ analytics: true })
    this.#close()
  }

  rejectAll() {
    setConsent({ analytics: false })
    this.#close()
  }

  // Save the granular preferences panel (essentials are always on; analytics is
  // the only opt-in category today).
  save() {
    setConsent({ analytics: this.hasAnalyticsTarget && this.analyticsTarget.checked })
    this.#close()
  }

  togglePanel() {
    if (this.hasPanelTarget) this.panelTarget.hidden = !this.panelTarget.hidden
  }

  #close() {
    if (this.hasPanelTarget) this.panelTarget.hidden = true
    this.element.hidden = true
  }
}
